import { useT } from "@/i18n/I18nContext";
import { Heart, Activity, AlertTriangle, Sparkles } from "lucide-react";

const BAND_STYLE = {
  strong: { bg: "bg-[#E6F6ED]", text: "text-[#166534]", border: "border-[#bce5cc]", Icon: Sparkles },
  ok:     { bg: "bg-[#FDFBF7]", text: "text-[#11322A]", border: "border-[#E0E4E2]", Icon: Heart },
  watch:  { bg: "bg-[#fff5e6]", text: "text-[#B45309]", border: "border-[#fcd9a3]", Icon: Activity },
  risk:   { bg: "bg-[#FDE8E6]", text: "text-[#B91C1C]", border: "border-[#F5B6B0]", Icon: AlertTriangle },
};

/**
 * Compact health-score badge. Shows the 0-100 score + a color-coded band.
 * Used in attorney/admin case lists and detail headers.
 */
export default function HealthScoreBadge({ health, size = "md" }) {
  const t = useT();
  if (!health) return null;
  const band = health.band || "ok";
  const score = health.score ?? 0;
  const { bg, text, border, Icon } = BAND_STYLE[band] || BAND_STYLE.ok;
  const isCompact = size === "sm";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border ${bg} ${text} ${border} ${isCompact ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs"} font-bold uppercase tracking-wider`}
      data-testid={`health-badge-${band}`}
      title={t("health.tooltip", { score })}
    >
      <Icon className={isCompact ? "h-2.5 w-2.5" : "h-3 w-3"} />
      <span>{score}</span>
      <span className="opacity-70">{t(`health.band.${band}`)}</span>
    </span>
  );
}
